import { api } from "@/lib/apiClient";
import type { MaListItem } from "@/lib/material";

export interface BestellwesenOverviewSection<T> {
  items: T[];
  total: number;
  truncated: boolean;
}

export interface BestellwesenAnfrageOverviewItem {
  id: number;
  subject: string | null;
  supplier_name: string | null;
  supplier_gp_id?: number | null;
  supplier_has_logo?: boolean | null;
  supplier_logo_updated_at?: string | null;
  status: string;
  created_at: string;
  created_by: string;
  position_count: number;
  ta_nummern?: string[];
  source_ma?: { id: number; ma_nummer?: string | null } | null;
}

export interface BestellwesenOrderOverviewItem {
  id: number;
  subject: string | null;
  supplier_name: string | null;
  supplier_gp_id?: number | null;
  supplier_has_logo?: boolean | null;
  supplier_logo_updated_at?: string | null;
  created_at: string;
  created_by: string;
  bestellnummern: string | null;
  days_open: number;
}

export interface BestellwesenOverview {
  stale_order_days: number;
  offene_materialanforderungen: BestellwesenOverviewSection<MaListItem>;
  materialanforderungen_in_bearbeitung: BestellwesenOverviewSection<MaListItem>;
  offene_anfragen: BestellwesenOverviewSection<BestellwesenAnfrageOverviewItem>;
  ueberfaellige_bestellungen: BestellwesenOverviewSection<BestellwesenOrderOverviewItem>;
}

export async function fetchBestellwesenOverview(): Promise<BestellwesenOverview> {
  return api.get<BestellwesenOverview>("/bestellwesen/overview");
}
